import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">NY City Cannabis · Informational Hub</p>
        <h1>Welcome to NY City Cannabis</h1>
        <p className="lede">
          Your go-to source for the latest updates on cannabis policy and culture in New York City. 
          Stay informed with our comprehensive coverage of local laws, legal status, and educational resources.
        </p>
        <div className="cta-row">
          <a href="/latest-updates" target="_self">
            Explore Latest Updates
          </a>
          <a href="/educational-resources" target="_self" className="secondary">
            Access Educational Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Law Updates</h2>
          <p>
            Stay up-to-date with the latest changes in cannabis legislation and policy in New York City.
          </p>
        </article>
        <article>
          <h2>Understanding Legal Status</h2>
          <p>
            Get clear information about the current legal status of cannabis use and possession in your area.
          </p>
        </article>
        <article>
          <h2>Educational Insights</h2>
          <p>
            Access a wealth of resources designed to educate the public on cannabis culture and its implications.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;